import {
  ConfirmItemKeywordType,
  ConfirmItemSearchParams,
  ConfirmStatus,
  Sort,
} from 'types/marketplace/confirmItem';
import { getUtcDateDash, getUtcDateDashDifference } from 'modules/utils/time';
import { SearchDateTerms } from 'types/common/searchfilter';
import { ContestOngoingFilterType } from 'types/marketplace/operation/contest';
import { GroupPlanHistoryStatus } from 'types/groups/detail';
import { DateForm } from '../../hooks/commons/useSearchFilterForm';
import { getDateForm } from '../../modules/common';
import { CLOSETGroupsPlanType } from 'types/api/groups/closet';
import { DEFAULT_SEARCH_TYPE } from './searchType';
import { CLOSETPaymentMethod } from 'types/groups';

export const initialSearchDateParams: ConfirmItemSearchParams = {
  dateFrom: getUtcDateDashDifference(new Date(), 1, 'month'),
  dateTo: getUtcDateDash(new Date()),
  dateTerm: SearchDateTerms['1_MONTH'],
  statuses: [
    ConfirmStatus.PENDING,
    ConfirmStatus.CHECKING,
    ConfirmStatus.PUBLISHED,
    ConfirmStatus.REJECTED,
  ],
  itemTypes: [],
  salesTypes: [],
  softwares: [],
  contestFilter: [String(ContestOngoingFilterType.NONE), String(ContestOngoingFilterType.CLOSED)],
  convertingStatuses: [],
  mdPick: false,
  curatorsPick: false,
  keyword: '',
  keywordType: ConfirmItemKeywordType.ItemName,
  page: 1,
  sort: Sort.LATEST_UPDATE,
  limit: 0,
};

export const planTypeName: { [key in CLOSETGroupsPlanType]: string } = {
  [CLOSETGroupsPlanType.FREE]: 'Free',
  [CLOSETGroupsPlanType.STANDARD]: 'Standard',
  [CLOSETGroupsPlanType.PREMIUM]: 'Premium',
  [CLOSETGroupsPlanType.STANDARD_TRIAL]: 'Standard Trial',
  [CLOSETGroupsPlanType.PREMIUM_TRIAL]: 'Premium Trial',
  [CLOSETGroupsPlanType.ACADEMIC]: 'Academic',
  [CLOSETGroupsPlanType.ADVANCED]: 'Advanced',
};

export const planTypeOptions = [
  { value: CLOSETGroupsPlanType.FREE, label: planTypeName[CLOSETGroupsPlanType.FREE] },
  {
    value: CLOSETGroupsPlanType.STANDARD,
    label: planTypeName[CLOSETGroupsPlanType.STANDARD],
  },
  { value: CLOSETGroupsPlanType.PREMIUM, label: planTypeName[CLOSETGroupsPlanType.PREMIUM] },
  {
    value: CLOSETGroupsPlanType.ACADEMIC,
    label: planTypeName[CLOSETGroupsPlanType.ACADEMIC],
  },
  { value: CLOSETGroupsPlanType.ADVANCED, label: planTypeName[CLOSETGroupsPlanType.ADVANCED] },
  {
    value: CLOSETGroupsPlanType.STANDARD_TRIAL,
    label: planTypeName[CLOSETGroupsPlanType.STANDARD_TRIAL],
  },
  {
    value: CLOSETGroupsPlanType.PREMIUM_TRIAL,
    label: planTypeName[CLOSETGroupsPlanType.PREMIUM_TRIAL],
  },
];

export const paymentMethodName: { [key in CLOSETPaymentMethod]: string } = {
  [CLOSETPaymentMethod.NONE]: 'None', // '-'
  [CLOSETPaymentMethod.STRIPE]: 'Stripe',
  [CLOSETPaymentMethod.INVOICE]: 'Invoice',
};

export const paymentMethodOptions = [
  {
    value: CLOSETPaymentMethod.STRIPE,
    label: paymentMethodName[CLOSETPaymentMethod.STRIPE],
  },
  {
    value: CLOSETPaymentMethod.INVOICE,
    label: paymentMethodName[CLOSETPaymentMethod.INVOICE],
  },
  {
    value: CLOSETPaymentMethod.NONE,
    label: paymentMethodName[CLOSETPaymentMethod.NONE],
  },
];

export const planHistoryStatusName: { [key in GroupPlanHistoryStatus]: string } = {
  [GroupPlanHistoryStatus.RESERVED]: 'Reserved',
  [GroupPlanHistoryStatus.CANCELLED]: 'Cancelled',
  [GroupPlanHistoryStatus.CURRENT]: 'Current',
  [GroupPlanHistoryStatus.COMPLETED]: 'Completed',
};

export const initialGroupsDateForm: DateForm = getDateForm(initialSearchDateParams);
export const initialPlanTypeValues: number[] = planTypeOptions.map(option => option.value);
export const initialPaymentMethodValues: number[] = paymentMethodOptions.map(
  option => option.value,
);

export const initialGroupsSearchFilter = {
  dateInterval: initialGroupsDateForm.dateInterval,
  dateTerm: initialGroupsDateForm.dateTerm,
  planTypeValues: initialPlanTypeValues,
  paymentMethodValues: initialPaymentMethodValues,
  keyword: initialSearchDateParams.keyword,
  searchType: DEFAULT_SEARCH_TYPE,
  manager: null,
};
